import { FC } from 'react';
import { Icon, IconType } from 'atoms/Icon';
import { Link } from 'atoms/Link/Link';
import { Span } from 'atoms/Typography';
import { gtmPushShopNavigation } from 'modules/gtm/modules/sections/navigation/navigation';
import { useTranslations } from 'modules/i18n/useTranslations';
import { AppRoutes } from 'modules/shop/routes';
import { useWishlist } from 'modules/shop/wishlist/useWishlist';
import styles from '../styles.module.css';

export const WishlistIcon: FC<{ className?: string }> = ({ className }) => {
  const t = useTranslations();
  const { total } = useWishlist();
  const gtmWishlistEventLabel = t('header.gtmNavigationLabels.wishlistIcon');

  const handleWishlistIconClick = () => {
    gtmPushShopNavigation(gtmWishlistEventLabel);
  };

  return (
    <Link
      href={AppRoutes.WISHLIST}
      className={styles.icon}
      onClick={handleWishlistIconClick}
    >
      {!!total && <Span className={styles.counter}>{total}</Span>}
      <Icon type={IconType.heartbordered} className={className} />
    </Link>
  );
};
